export const HR_SETTINGS = 'hsHR';
export const hshrConfig = {
  DISABLE_INSERTION: 'disableInsertion'
};